// vueform.config.(js|ts)

import it from '@vueform/vueform/locales/it'
import vueform from '@vueform/vueform/dist/vueform'
import { defineConfig } from '@vueform/vueform'

// You might place these anywhere else in your project
import '@vueform/vueform/dist/vueform.css';

export default defineConfig({
  theme: vueform,
  locales: { it },
  locale: 'it',
})